import { render, staticRenderFns } from "./NewNavigationItems.vue?vue&type=template&id=1f5a6772&scoped=true"
import script from "./NewNavigationItems.vue?vue&type=script&lang=ts"
export * from "./NewNavigationItems.vue?vue&type=script&lang=ts"
import style0 from "./NewNavigationItems.vue?vue&type=style&index=0&id=1f5a6772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a6772",
  null
  
)

export default component.exports